import React from 'react'
import styled from '@emotion/styled'

import { colors } from 'Constants'

const Tag = styled.div`
  border-radius: 20px;
  padding: 5px 12px;
  color: ${colors.textOnPrimary};
  text-align: center;
  width: 80px;
  margin-top: 10px;
`

const ActiveTag = styled(Tag)`
  background-color: ${colors.darkGreen};
`

const InactiveTag = styled(Tag)`
  background-color: ${colors.red};
`

export default ({ isActive, text }) => {
  if (isActive) {
    return <ActiveTag>{text}</ActiveTag>
  }

  return <InactiveTag>{text}</InactiveTag>
}
